import React, { Component } from 'react'
import {
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  CardTitle,
  Button,
  Label,
  InputGroup,
  InputGroupAddon,
  Input,
  Alert
} from 'reactstrap'
import EditableCard from '../../components/EditableCard'
import { Prompt } from 'react-router-dom'

class Settings extends Component {
  constructor(props) {
    super(props)

    this.state = {
      editingMode: false,
      profile: this.props.userInfo
    }

    this.setEditingMode = this.setEditingMode.bind(this)
    this.updateModel = this.updateModel.bind(this)
  }

  setEditingMode(editingMode) {
    this.setState({ editingMode })
  }

  updateModel(model, data) {
    this.setState({
        [model]: data
    })
  }

  render() {
    const cards = [
      {
        cardTitle: 'Name',
        fetchData: {
          method: 'patch',
          endpoint: `users/${this.props.userInfo.id}`,
        },
        cardFields: [
          {
            id: 'first_name',
            fieldLabel: 'Vorname',
            fieldType: 'text',
            fieldValue: this.state.profile.first_name,
            fieldRequired: true
          },
          {
            id: 'last_name',
            fieldLabel: 'Nachname',
            fieldType: 'text',
            fieldValue: this.state.profile.last_name,
            fieldRequired: true
          }
        ]
      }, {
        cardTitle: 'Passwort',
        cardType: 'always-on',
        fetchData: {
          method: 'patch',
          endpoint: `users/${this.props.userInfo.id}`,
        },
        cardInstructions: <Alert color="info">Bitte stellen Sie sicher, dass das Passwort zu diesen Kriterien passt:
                            <ul className="mb-0 pl-4">
                              <li>Mindestens 8 Zeichen lang</li>
                              <li>Kein einfaches Passwort wie "EinZweiDrei" oder "Passwort"</li>
                              <li>Mit mindestens einem Buchstaben</li>
                              <li>Keine Ähnlichkeit oder Übereinstimmung mit Ihrer E-Mail-Adresse</li>
                            </ul>
                          </Alert>,
        cardFields: [
          {
            id: 'old_password',
            fieldLabel: 'Aktuelles Passwort',
            fieldType: 'password',
            fieldRequired: true
          },
          {
            id: 'password',
            fieldLabel: 'Neues Passwort',
            fieldType: 'password',
            fieldRequired: true
          },
          {
            id: 'password_repeat',
            fieldLabel: 'Passwort wiederholen',
            fieldType: 'password',
            fieldRequired: true
          }
        ],
        cardSubmitMessage: "Änderungen wurden gespeichert."
      }, {
        cardTitle: 'E-Mail',
        cardType: 'always-on',
        fetchData: {
          method: 'patch',
          endpoint: `users/${this.props.userInfo.id}`,
        },
        cardFields: [
          {
            id: 'email',
            fieldLabel: 'Neue E-Mail',
            fieldType: 'email',
            fieldRequired: true
          }
        ],
        cardSubmitMessage: "Wir haben eine Bestätigungs E-Mail and Ihre Adresse geschickt. Klicken Sie auf den Link in dieser E-Mail um Ihre neue E-Mail-Adresse zu bestätigen."
      }
    ]

    return (
      <div className="animated fadeIn">
        <Prompt
            when={this.state.editingMode}
            message={`Änderungen verwerfen?`}
          />
        <Row>
          <Col>
            {cards.map((el, index) => <EditableCard
                                        userInfo={this.props.userInfo}
                                        key={index}
                                        {...el}
                                        getEditingMode={this.state.editingMode}
                                        setEditingMode={this.setEditingMode}
                                        updateModel={this.updateModel}
                                      />)}
          </Col>
        </Row>
      </div>
    )
  }
}

export default Settings



// WEBPACK FOOTER //
// ./src/views/Settings/Settings.js